import { truncateHtmlAt } from 'hb-react/shared/utils/truncateHtmlAt';

export const HtmlContent = ({
  content,
  max,
}: {
  content: string;
  max?: number;
}) => (
  <div
    dangerouslySetInnerHTML={{
      __html: max ? truncateHtmlAt(content, max).html : content,
    }}
  />
);
